import { AuthService } from '@/app/features/pre-login/services/login-service/auth-service';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, merge, Observable, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { UserService } from '../user-service/user-service';
import { environment } from '@/environments/environment';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class AutoLogoutService {
  private inactivityTimer: any;
  private showAlertTimer: any;
  private userActivitySubscription: Subscription | undefined;
  // private readonly INACTIVITY_TIME_MS = 20 * 1000; // 30 minutes
  private readonly INACTIVITY_TIME_MS = environment.AUTO_LOGOUT_TIME; // 30 minutes

  constructor(
    private ngZone: NgZone,
    private userService: UserService,
    private matDialog: MatDialog
  ) {}

  startTracking() {
    this.ngZone.runOutsideAngular(() => {
      const activityEvents = merge(
        fromEvent(document, 'mousemove'),
        fromEvent(document, 'keydown'),
        fromEvent(document, 'click'),
        fromEvent(document, 'scroll')
      ).pipe(debounceTime(500)); // Debounce to avoid excessive event handling

      this.userActivitySubscription = activityEvents.subscribe(() => {
        this.resetTimer();
      });
    });

    this.resetTimer(); // Initialize the timer on start
  }

  stopTracking() {
    if (this.userActivitySubscription) {
      this.userActivitySubscription.unsubscribe();
    }
    clearTimeout(this.showAlertTimer);
    clearTimeout(this.inactivityTimer);
  }

  resetTimer() {
    clearTimeout(this.inactivityTimer);
    clearTimeout(this.showAlertTimer);
    this.ngZone.runOutsideAngular(() => {
      this.inactivityTimer = setTimeout(() => {
        this.ngZone.run(() => {
          this.matDialog.closeAll();
          this.userService.logout();
          this.stopTracking();
        });
      }, this.INACTIVITY_TIME_MS);
      // this.showAlertTimer = setTimeout(() => {
      //   this.ngZone.run(() => {
      //     alert('You will be logged out after 5 mins due to inactivity.');
      //     this.resetTimer();
      //   });
      // }, this.INACTIVITY_TIME_MS - 5000);
    });
  }
}
